import React from 'react';

const TESTIMONIALS = [
  {
    quote:
      'Thanks for the reading Charu! It was a great chat and I loved the marketing tarot card I picked. It was perfect!',
    name: 'Rachel Fiegler',
    role: 'Co-founder & CEO, The Pinpointe Group',
  },
  {
    quote:
      "So great talking with you Charu! Thank you for the opportunity to talk about building trust in AEO. There's so much potential in marketing content that's designed for the right goals and built the right ways.",
    name: 'Doug Pohl',
    role: 'Fractional Content & Thought Leadership Executive, MarketingFeels',
  },
  {
    quote:
      'Such a blast recording this! Charu your questions were so spot-on — they really hit the heart of what it takes for wellness and beauty brands to scale today. Thank you for the wonderful conversation and reading.',
    name: 'Nastia Rubezhanska',
    role: 'Partnerships Manager, Admiral Studios',
  },
  {
    quote:
      'What really happens when you keep delaying a decision you know you should take? It does not show up immediately, but it stays with you much longer than you expect. This came up when Charu Verma Pandey asked me this in our conversation.',
    name: 'Khushboo Nangalia',
    role: 'Founder & CEO, Salt & Pepper Academy',
  },
];

export const Reflections = ({ className = 'mt-24' }) => {
  return (
    <section className={`${className} max-w-6xl mx-auto px-2`} data-testid="reflections-section">
      <div className="text-center mb-12">
        <p className="font-display text-xs tracking-[0.3em] text-[#e89b47] mb-4 uppercase">
          Reflections
        </p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl text-[#e8dcc8] leading-tight mb-4">
          What people are <span className="text-[#e89b47]">saying</span>
        </h2>
        <p className="font-body text-sm text-[#d4c4a8]/60 max-w-xl mx-auto">
          Voices from the founders, creators, and teams who&rsquo;ve drawn a card.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <div
            key={i}
            className="p-6 rounded-2xl bg-[#1e2a4a]/40 border border-[#d4c4a8]/10 hover:border-[#e89b47]/30 transition-colors flex flex-col"
            data-testid={`reflection-${i}`}
          >
            <div className="font-display text-3xl text-[#e89b47]/50 leading-none mb-3">
              &ldquo;
            </div>
            <p className="font-body text-sm text-[#d4c4a8]/80 leading-relaxed italic flex-1">
              {t.quote}
            </p>
            <div className="mt-5 pt-5 border-t border-[#d4c4a8]/10">
              <p className="font-display text-sm text-[#e8dcc8]">{t.name}</p>
              <p className="font-body text-xs text-[#d4c4a8]/50 mt-0.5">{t.role}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Reflections;
